export class Base {
    id?: string | number
    created_at?: string | Date
    updated_at?: string | Date
    deleted_at?: string | Date
}